import { AdminReproduction } from "../../admin/adminReproduction/adminReproduction";

export const EleveurReproduction = () => {
  return <AdminReproduction />;
};